
import React, { useState } from 'react';
import { Box, Container, Grid } from '@mui/material';
import SelectRange from '../../components/dashboard/SelectRange/';
import OcorrenciasPorCategorias from '../../components/dashboard/TablesOccurrences/OcorrenciasPorCategorias';
import OcorrenciasPorBairros from '../../components/dashboard/TablesOccurrences/OcorrenciasPorBairros';
import GraphQuantOccurrence from '../../components/dashboard/GraphQuantOccurrence';
import BoxQuantOpenOccurrences from '../../components/dashboard/BoxQuantOpenOccurrences';
import BoxQuantOccurrencesSolved from '../../components/dashboard/BoxQuantOccurrencesSolved';
import BoxPercentageOccurrencesSolved from '../../components/dashboard/BoxPercentageOccurrencesSolved';
import OccurrenceByStatus from '../../components/dashboard/OccurrenceByStatus';
import MultiManual from '../../components/Manual/MultiManual';
import usePollingInterval from '../../hooks/usePollingInterval';
import './styles.css';
import manualJson from './manual.json';

const Dashboard = () => {
  //Estado onde será armazenado as ocorrência do período selecionado
  const [occurrences, setOccurrences] = useState([]);
  const [rangeOccurrences, setRangeOccurrences] = useState({
    startDate: new Date(2021, 0, 1),
    endDate: new Date(),
    key: 'selection'
  })


  const [refreshTrigger, setRefreshTrigger] = useState(0);
  usePollingInterval(() => setRefreshTrigger(t => t + 1));

  return (
    <>
      <div className="dash-container">
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 5,
          }}
        >
          <Container maxWidth={false}>
            <Grid
              container
              spacing={1}
            >
              <Grid
                item
                lg={3}
                sm={6}
                xl={3}
                xs={12}
              >
                <div id='select-range-dashboard'>
                  <SelectRange
                    setOccurrences={setOccurrences}
                    setRangeOccurrences={setRangeOccurrences}
                    rangeOccurrences={rangeOccurrences}
                    refreshTrigger={refreshTrigger}
                  />
                </div>
              </Grid>
              <Grid
                item
                lg={3}
                sm={6}
                xl={3}
                xs={12}
              >
                <div id='occurrences-solved-dashboard'>
                  <BoxQuantOccurrencesSolved occurrences={occurrences} />
                </div>
              </Grid>
              <Grid
                item
                lg={3}
                sm={6}
                xl={3}
                xs={12}
              >
                <div id='occurrences-open-dashboard'>
                  <BoxQuantOpenOccurrences occurrences={occurrences} />
                </div>
              </Grid>
              <Grid
                item
                lg={3}
                sm={6}
                xl={3}
                xs={12}
              >
                <div id='occurrences-solved-percentage-dashboard'>
                  <BoxPercentageOccurrencesSolved occurrences={occurrences} />
                </div>
              </Grid>
              <Grid
                item
                lg={8}
                md={12}
                xl={9}
                xs={12}
              >
                <div id='occurrences-gaph-dashboard'>
                  <GraphQuantOccurrence
                    startDate={rangeOccurrences.startDate}
                    endDate={rangeOccurrences.endDate}
                    occurrences={occurrences}
                  />
                </div>

              </Grid>
              <Grid
                item
                lg={4}
                md={6}
                xl={3}
                xs={12}
              >
                <div id='occurrences-status-dashboard'>
                  <OccurrenceByStatus occurrences={occurrences} />
                </div>
              </Grid>

              <Grid
                item
                lg={12}
                md={12}
                xl={12}
                xs={12}
              >
                <div id='occurrences-neighborhood-dashboard'>
                  <OcorrenciasPorBairros occurrences={occurrences} />
                </div>
              </Grid>
              <Grid
                item
                lg={12}
                md={12}
                xl={12}
                xs={12}
              >
                <div id='occurrences-category-dashboard'>
                  <OcorrenciasPorCategorias occurrences={occurrences} />
                </div>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <br />

        <MultiManual components={manualJson} />
      </div>
    </>
  );
}
export default Dashboard;
